<template>
  <div>
    <v-container v-if="sessionLoggedIn()">
      <v-navigation-drawer
        v-model="toggle"
        absolute
        right
        light
        temporary
        width="300px"
      >
        <v-list-item>
          <v-list-item-avatar class="avatar">
            {{ sessionDetails().initials }}
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{
              sessionDetails().fullName
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- First -->
        <div>
          <v-progress-linear
            v-if="loading"
            indeterminate
            height="10"
          ></v-progress-linear>
        </div>
        <v-expansion-panels focusable>
          <v-expansion-panel
            v-for="(firstItem, firstIndex) in levelItems(null, 1)"
            :key="firstIndex"
          >
            <div v-if="hasChild(firstItem.name)">
              <v-expansion-panel-header>
                <v-icon v-if="firstItem && firstItem.icon">{{
                  firstItem.icon
                }}</v-icon>
                <v-spacer v-if="firstItem && firstItem.icon"></v-spacer>
                <span>{{ firstItem.title }}</span>
                <v-spacer></v-spacer>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <!-- Second -->
                <v-list>
                  <div
                    v-for="(secondItem, secondIndex) in levelItems(
                      firstItem.name,
                      2
                    )"
                    :key="secondIndex"
                  >
                    <div v-if="hasChild(secondItem.name)">
                      <v-expansion-panels>
                        <v-expansion-panel>
                          <v-expansion-panel-header>
                            <v-icon v-if="secondItem && secondItem.icon">{{
                              secondItem.icon
                            }}</v-icon>
                            <span>{{ secondItem.title }}</span>
                            <v-spacer></v-spacer>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <!-- Third -->
                            <v-list>
                              <div
                                v-for="(thirdItem, thirdIndex) in levelItems(
                                  secondItem.name,
                                  3
                                )"
                                :key="thirdIndex"
                              >
                                <v-list-item link>
                                  <v-list-item-title @click="thirdItem.action">
                                    <v-icon
                                      v-if="thirdItem && thirdItem.icon"
                                      >{{ thirdItem.icon }}</v-icon
                                    >
                                    <span>{{ thirdItem.title }}</span>
                                    <v-spacer></v-spacer>
                                  </v-list-item-title>
                                </v-list-item>
                              </div>
                            </v-list>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </div>

                    <div v-else>
                      <v-list-item link>
                        <v-list-item-title @click="secondItem.action">
                          <v-spacer
                            v-if="secondItem && secondItem.icon"
                          ></v-spacer>
                          <v-icon v-if="secondItem && secondItem.icon">{{
                            secondItem.icon
                          }}</v-icon>
                          <span>{{ secondItem.title }}</span>
                          <v-spacer></v-spacer>
                        </v-list-item-title>
                      </v-list-item>
                    </div>
                  </div>
                </v-list>
              </v-expansion-panel-content>
            </div>
            <div v-else>
              <v-list-item link>
                <v-list-item-title @click="firstItem.action">
                  <v-spacer v-if="firstItem && firstItem.icon"></v-spacer>
                  <v-icon v-if="firstItem && firstItem.icon">{{
                    firstItem.icon
                  }}</v-icon>
                  <span>{{ firstItem.title }}</span>
                  <v-spacer></v-spacer>
                </v-list-item-title>
              </v-list-item>
            </div>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-navigation-drawer>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "MenuBarFrame",
  props: [
    "menuBarDrawer",
    "session",
    "environment",
    "applicationName",
    "generalExApplicationEx",
    "customLanguage",
  ],
  data() {
    return {
      toggle: false,
      menuEx: {},
      selected: 0,
      selectedItem: -1,
      items: [],
      loadedMenus: false,
      loading: false,
    };
  },
  methods: {
    parseItems(getItems, getInit) {
      let jump = -1;
      for (let i = getInit; i < this.menuEx.menus.length; i++) {
        let menu = this.menuEx.menus[i];

        if (i >= jump) {
          // Add Item
          let item = {
            title: this.translatedConfig(
              this.generalExApplicationEx,
              this.customLanguage,
              menu,
              "caption"
            ),
            index: i,
            active: true,
            action: () => {
              this.clickMenu(menu.transactionName, i);
            },
          };

          getItems.push(item);

          // Handle Level Structure
          if (i < this.menuEx.menus.length - 1) {
            let next = this.menuEx.menus[i + 1];

            if (next.level > menu.level) {
              item.items = [];
              item.items = this.parseItems(item.items, i + 1);
              jump = i + item.items.length + 1;
            } else if (next.level < menu.level) {
              break;
            }
          }
        }
      }
      return getItems;
    },

    loadMenus() {
      // const session = this.appContextLoadSession({
      //   applicationName: this.applicationName,
      //   generalExApplicationEx: this.generalExApplicationEx,
      // });
      this.loading = true;
      this.apiLoadMenus({
        path: { applicationName: this.applicationName },
        body: this.sessionDetails().roles
          ? Array.isArray(this.sessionDetails().roles)
            ? this.sessionDetails().roles
            : this.sessionDetails().roles.split(",")
          : [],
      })
        .then((menuRes) => {
          this.menuEx = menuRes.data;
          if (this.menuEx.menus.length > 0) {
            this.items = [];
            this.parseItems(this.items, 0);
            this.loadedMenus = true;
          } else {
            this.goToLogin(this.applicationName);
          }
          this.loading = false;
        })
        .catch((menuErr) => {
          console.log(menuErr);
          this.loadedMenus = false;
          this.loading = false;
        });
    },

    clickMenu(transactionName, index) {
      if (this.notBlank(transactionName)) {
        this.toggle = false;

        //let data = {};
        //this.$emit("sel-menu", data);

        let data = this.menuEx.menus[index];
        this.$emit("sel-menu", data);

        this.$emit("toggle-menu-bar-drawer");
      }
    },

    levelItems(parentName, level) {
      let outItems = [];
      if (this.loadedMenus) {
        this.menuEx.menus.forEach((menu, i) => {
          if (menu.parentName == parentName) {
            const item = {
              index: i,
              title: this.translatedConfig(
                this.generalExApplicationEx,
                this.customLanguage,
                menu,
                "caption"
              ),
              level: level,
              name: menu.menuName,
              icon: menu.icon,
              action: () => {
                this.clickMenu(menu.transactionName, i);
              },
            };
            outItems.push(item);
          }
        });
      }
      return outItems;
    },

    hasChild(menuName) {
      let loaded = false;
      let numChild = 0;
      if (this.loadedMenus) {
        loaded = true;
        this.menuEx.menus.forEach((menu) => {
          if (menu.parentName == menuName) {
            numChild++;
          }
        });
      }
      return loaded && numChild > 0;
    },

    toggleMenuBarDrawer() {
      this.toggle = !this.toggle;
      this.loadMenus();
    },

    sessionLoggedIn() {
      return this.session?.loggedIn;
    },
    sessionDetails() {
      return this.session?.details;
    },
  },
  updated() {},
  mounted() {},
};
</script>

<style>
.avatar {
  background-color: gray;
  color: white;
}
</style>